import { JonumVerificationStatus } from '#src/__generated__/globalTypes.ts';

// The backend reports EXEMPTION_EXPIRED once an exemption is older than its
// recheck period: the record still exists, but it says nothing about the user
// until createJonumVerification reclassifies them from the current IP.
// Reclassifying from a French IP re-enters the JONUM flow; from anywhere else
// it just renews the exemption, so keep treating the user as exempt.
export const isJonumExempt = (
  status: JonumVerificationStatus | undefined,
  isInAffectedCountry: boolean
) =>
  status === JonumVerificationStatus.EXEMPT ||
  (status === JonumVerificationStatus.EXEMPTION_EXPIRED &&
    !isInAffectedCountry);
